import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@intersystems/notification';
import { User, UsersService } from 'api';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss'],
})
export class AccountPageComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private router: Router,
    private notificationService: NotificationService,
  ) {}
  user: User;

  onDetailsEdit(formModel: any) {
    const userData: any = { first_name: formModel.firstName, last_name: formModel.lastName };
    this.usersService
      .patchUser(this.user.username, userData)
      .pipe(switchMap(() => this.authService.authorise('', '')))
      .subscribe(
        () => this.notificationService.showSuccess('Successfully updated', 7000),
        error => {
          let signUpFailMessage = error.message;
          if (signUpFailMessage.includes('#')) {
            signUpFailMessage = signUpFailMessage.split('#')[1].replace('.', '');
          }
          this.notificationService.showAlert(`Edit User Failed: ${signUpFailMessage}`, 7000);
        },
      );
  }

  onPasswordEdit(formModel: any) {
    this.authService.updatePassword(formModel.currentPassword, formModel.confirmPassword).subscribe(
      () => {
        this.notificationService.showSuccess('Successfully changed password. Please log in again.', 7000);
        this.router.navigate(['/account/login']);
      },
      error => {
        let signUpFailMessage = error.message;
        if (signUpFailMessage.includes('#')) {
          signUpFailMessage = signUpFailMessage.split('#')[1].replace('.', '');
        }
        this.notificationService.showAlert(`Change Password Failed: ${signUpFailMessage}`, 7000);
      },
    );
  }

  ngOnInit(): void {
    this.user = this.authService.user;
  }
}
